import React from 'react';
import Scrapbook from './components/Scrapbook';

export default function App() {
  return (
    <main>
      <Scrapbook />
    </main>
  );
}
